import { createSlice } from "@reduxjs/toolkit";

/**
 * Returns an object of Meristem experiments and their startEvents
 * This object is in the shape of
 * {
 *   experimentName: { startEvent: { filters }, ... },
 *   ...
 * }
 */
function extractStartEvents(meristemExperiments) {
  const startEvents = {};
  if (meristemExperiments) {
    meristemExperiments.forEach((meristemExperiment) => {
      const experimentName = meristemExperiment.name;
      if (meristemExperiment.startEvents) {
        startEvents[experimentName] = {};
        meristemExperiment.startEvents.forEach((startEvent) => {
          const { filters } = startEvent;
          startEvents[experimentName][startEvent.name] = {
            filters,
          };
        });
      }
    });
  }
  return startEvents;
}

const startEventsSlice = createSlice({
  name: "startEvents",
  initialState: {},
  reducers: {
    updateStartEvents(state, action) {
      return extractStartEvents(action.payload) || state;
    },
  },
});

export const { updateStartEvents } = startEventsSlice.actions;

export default startEventsSlice.reducer;
